export default {
  data() {
    return {
      call_again: [
        {
          id: 1,
          name: "Reasons",
          alias: "REASONS",
          chartTab: "STATUS"
        },
        {
          id: 2,
          name: "Priority",
          alias: "PRIORITY",
          chartTab: "PRIORITY"
        }
        // {
        //   id: 3,
        //   name: "Auto Status",
        //   alias: "AUTO_STATUS",
        //   chartTab: "AUTO_STATUS"
        // }
      ]
    };
  },

  created() {
    if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
      this.call_again = [
        ...this.call_again,
        {
          id: 4,
          name: "Users",
          alias: "USERS",
          chartTab: "USERS"
        }
      ];
      this.insertAndShift(this.call_again, 2, 0);
    }
  },
  methods: {
    insertAndShift(arr, from, to) {
      let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
      arr.splice(to, 0, cutOut); // insert it at index 'to'
    }
  }
};
